import Link from 'next/link';
import { Image } from '@petsmart-ui/sparky';
import type { NavCardProps } from '../types';
import './NavCard.scss';
import { Text } from '../../../Text';

export function NavCard({
    icon,
    header,
    link,
    backgroundFill: background,
    textColor = 'Dark Grey',
    handleAnalytics,
}: NavCardProps) {
    const Component = link ? Link : 'div';

    return (
        <Component
            className="nav-card"
            href={link?.webUrl ?? ''}
            style={{ background }}
            onClick={handleAnalytics}
            prefetch={false} // https://petsmart.atlassian.net/browse/HCP-594
        >
            <Image src={icon?.webLink} alt={`${header} icon`} />
            <Text color={textColor} as="h3">
                {header}
            </Text>
        </Component>
    );
}
